export type ComposerKeydownLike = {
  key: string;
  shiftKey?: boolean;
  isComposing?: boolean;
};

export function shouldSubmitComposerOnKeydown(_event: ComposerKeydownLike) {
  return false;
}
